var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33325 4.99967C8.33325 4.0792 9.07944 3.33301 9.99992 3.33301H10.0099C10.9304 3.33301 11.6766 4.0792 11.6766 4.99967C11.6766 5.92015 10.9304 6.66634 10.0099 6.66634H9.99992C9.07944 6.66634 8.33325 5.92015 8.33325 4.99967Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33325 9.99967C8.33325 9.0792 9.07944 8.33301 9.99992 8.33301H10.0099C10.9304 8.33301 11.6766 9.0792 11.6766 9.99967C11.6766 10.9201 10.9304 11.6663 10.0099 11.6663H9.99992C9.07944 11.6663 8.33325 10.9201 8.33325 9.99967Z",
    fill: "#334155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33325 14.9997C8.33325 14.0792 9.07944 13.333 9.99992 13.333H10.0099C10.9304 13.333 11.6766 14.0792 11.6766 14.9997C11.6766 15.9201 10.9304 16.6663 10.0099 16.6663H9.99992C9.07944 16.6663 8.33325 15.9201 8.33325 14.9997Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotVertical);
export default __webpack_public_path__ + "static/media/threeDotVertical.c35ec2f9a06ac6f66cb2740362918c26.svg";
export { ForwardRef as ReactComponent };